
export const lang = {
    // 按钮文言
    btn: {
        searchBtn: 'search',
        detailBtn: 'detail',
        deleteBtn: 'delete',
        modifyBtn: 'modify',
    },
    // placeholder
    plh: {
        // 共通
        sel: 'please select',
        // 发帖审核页面
        adsKey: '请输入发帖人搜索'
    },
  // start new By LiLiBin 2021/06/24 13:41
  lab_taskVenue: 'Venue',
  lab_taskVenueList: 'Venue List',
  // end new By LiLiBin 2021/06/24 13:41
  venue: {
	btn_addVenueType: 'Add Venue Type',
	label_venueName: 'Venue Name',
	label_resourceType: 'First Resource Type',
	tip_resourceName: 'Please Enter The Type Name',
	label_secResourceType: 'Second Resource Type',
	btn_addVenueType_first: 'Add First Resource Type',
	title_editVenueType_first: 'Edit First Resource Type',
	btn_back_first: 'Back to First Resource Type',
	btn_addVenueType_sec: 'Add Second Resource Type',
	title_editVenueType_sec: 'Edit Second Resource Type',
	btn_addVenue: 'Add Resource',
	btn_back_venue_management: 'Back to Venue Management',
	label_customNo: 'Custom No.',
	tip_input_customNo: 'Please input Custom No.',
	label_customName: 'Custom Name',
	tip_input_customName: 'Please input Custom Name',
	label_attribute: 'Attribute',
	tip_select_attribute: 'Please select Attribute',
	tip_input_area: 'Please input Area',
	tip_select_firstResource: 'Please select First Resource Type',
	tip_select_secResource: 'Please select Second Resource Type',
	tip_select_startDate: 'Please select Start Date',
	tip_select_endDate: 'Please select End Date',
	tip_select_health: 'Please select Health status',
	tip_select_status: 'Please select Business status',
	label_area: 'Area',
	label_startDate: 'Start Date',
	label_endDate: 'End Date',
	label_position: 'Position',
	tip_input_position: 'Please input Position',
	label_supplierName: 'Supplier Name',
	tip_input_supplierName: 'Please input Supplier Name',
	label_contactName: 'Contact Name',
	label_contactNumber: 'Contact Phone Number',
	tip_input_contactName: 'Please input Contact Name',
	tip_input_contactNumber: 'Please input Contact Phone Number',
	label_entrance: 'Entrance',
	tip_input_entrance: 'Please input Entrance',
	label_garden: 'Garden',
	label_house: 'Building',
	tip_select_house: 'Please select Building',
	label_unit: 'Unit',
	tip_select_unit: 'Please select Unit',
	label_lift: 'Lift Name',
	tip_input_lift: 'Please input Lift Name',
	label_healthLevel: 'Health Status',
	health: {
		level_good: 'Health',
		level_normal: 'Good',
		level_bad: 'Broken'
	},
	label_status: 'Business Status',
	status: {
		status_open: 'Open',
		status_close: 'Close'
	},
	label_basePrice: 'Cooperation Price',
	tip_input_basePrice: 'Please input Cooperation Price',
	label_customPrice: 'Custom Price',
	tip_input_customPrice: 'Please input Custom Price',
	label_remark: 'Remark',
	tip_input_remark: 'Please input Remark'
  }
  }